import React from 'react';

function AddressIcon() {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.6501 18.9794C28.6501 11.1894 22.905 4.87549 15.8167 4.87549C8.72845 4.87549 2.9834 11.1894 2.9834 18.9794C2.9834 24.1713 7.26118 30.9631 15.8167 39.3518C24.3723 30.9631 28.6501 24.1713 28.6501 18.9794Z"
        fill="#FF5200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.4582 17.7045C32.4582 10.7564 27.1048 5.125 20.4998 5.125C13.8949 5.125 8.5415 10.7564 8.5415 17.7045C8.5415 22.3352 12.5276 28.393 20.4998 35.875C28.4721 28.393 32.4582 22.3352 32.4582 17.7045ZM20.4998 22.2083C23.3303 22.2083 25.6248 19.9138 25.6248 17.0833C25.6248 14.2529 23.3303 11.9583 20.4998 11.9583C17.6694 11.9583 15.3748 14.2529 15.3748 17.0833C15.3748 19.9138 17.6694 22.2083 20.4998 22.2083Z"
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
}

export default AddressIcon;
